<template>
  <div>
    <div>
      <img src="@/assets/images/isoqualidade-cover.png" alt="iso" class="cover-iso" />
    </div>
    <div class="container" style="margin: 100px auto">
      <p>
        A certificação ISO 9001 possibilita que a organização demonstre seu compromisso com a qualidade e satisfação do cliente bem como o seu comprometimento com a melhoria
        contínua de seus sistemas da qualidade, integrando a realidade das mudanças mundiais. <br /><br />A Sibrol é uma empresa Certificada ISO 9001 pela SGS Certified, empresa
        sediada em Genebra, Suiça, líder mundial em certificação, verificação e teste em qualidade.<br /><br />
        Conheça nossa Política da Qualidade. Clique Aqui:
        <a :href="`${publicPath}POLITICAQUALIDADE.pdf`" download="download">POLITICA DA QUALIDADE</a> <br /><br />Para saber mais sobre o SGS CERTIFIED clique aqui:
        <a href="https://www.sgs.com/en/certified-clients-and-products" target="_blank"><img src="@/assets/images/SGSIso_9001pq.jpg" alt="SGS"/></a>
      </p>
      <p>Disponibilizamos para Download o Certificado ISO 9001 em duas versões, Português e Inglês.</p>
      <a :href="`${publicPath}CERTIFICADO_ISO9001_PORT.pdf`" download="download">DOWNLOAD PORTUGUÊS</a><br />
      <a :href="`${publicPath}CERTIFICADO_ISO9001_ING.pdf`" download="download">DOWNLOAD INGLÊS</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualityVue",
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.cover-iso {
  width: 100vw;
  max-height: 600px;
  object-fit: cover;
}
</style>
